// Entry point of the public bundle: the pages a visitor reads on a kennel or
// platform Site (`layouts/public`) and the owner's preview of one
// (`layouts/site_builder_preview`), which renders the same block partials.
//
// It carries what those pages use and nothing else (owner decision
// 2026-10-17, fix a28): Turbo, Stimulus, the controllers their markup names —
// the PhotoSwipe gallery (`gallery`), the carousel album's buttons
// (`carousel`, phase 074), the news feed (`progressive-list`), the ← and →
// keys between a post and its neighbours (`post-navigation`, phase 090), the
// footer's light/dark/system switch (`appearance`, phase 093), a post card's
// video in the lightbox (`video-card`, phase 093), the post page's `#play`
// (`autoplay`, phase 093), the look switcher of a listed Site's footer
// (`site-look`, phase 097) and the home's carousel of the kennel's marked
// photos (`home-carousel`, phase 102) and the contents column that marks the
// section in view (`section-spy`, phase 127) —,
// Tailwind Plus Elements for the locale switcher, the FAQ answers and the booking panel (both page bundles carry the library,
// owner decision 17.10.2026, `doc/base-ui-seo-pwa-i18n.md` 2.7), and the
// service-worker registration of the Site's PWA. The editor (Tiptap and
// ProseMirror), the upload surface (Uppy, tus), the reorder (SortableJS), the
// confirmation dialog and the billing and Web Push controllers belong to the
// cabinet and the admin, in `application.ts`; together they were most of the
// one bundle every visitor downloaded.
//
// The library is loaded through `lib/tailwind_elements_once.ts`, the
// package's one importer, at the top level of this bundle, which both public
// layouts load from `<head>`; a `<script>` in `<body>` would be re-run by
// Turbo on every visit. An open locale menu is closed before Turbo caches the
// page (`lib/elements_snapshot.ts`), so Back never shows it open.
//
// `spec/contracts/stimulus_registrations_spec.rb` holds this list to the
// controllers the views of those two layouts name, both ways. Like
// `application.ts`, it is built whole, with no code splitting
// (`esbuild.config.mjs`).
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

import AppearanceController from "./controllers/appearance_controller"
import AutoplayController from "./controllers/autoplay_controller"
import CarouselController from "./controllers/carousel_controller"
import GalleryController from "./controllers/gallery_controller"
import HomeCarouselController from "./controllers/home_carousel_controller"
import PostNavigationController from "./controllers/post_navigation_controller"
import ProgressiveListController from "./controllers/progressive_list_controller"
import SectionSpyController from "./controllers/section_spy_controller"
import SiteLookController from "./controllers/site_look_controller"
import VideoCardController from "./controllers/video_card_controller"
import { closeTransientElements } from "./lib/elements_snapshot"
import { deferDialogInvokers } from "./lib/dialog_invokers"
import { loadTailwindElementsOnce } from "./lib/tailwind_elements_once"
import { registerServiceWorker } from "./pwa/register"

void loadTailwindElementsOnce()
deferDialogInvokers()
document.addEventListener("turbo:before-cache", () => closeTransientElements())

const application = Application.start()
application.register("appearance", AppearanceController)
application.register("autoplay", AutoplayController)
application.register("carousel", CarouselController)
application.register("gallery", GalleryController)
application.register("home-carousel", HomeCarouselController)
application.register("post-navigation", PostNavigationController)
application.register("progressive-list", ProgressiveListController)
application.register("section-spy", SectionSpyController)
application.register("site-look", SiteLookController)
application.register("video-card", VideoCardController)

registerServiceWorker()
